// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#product-info-form[data-v-b61e5f7c] .el-upload-list--picture-card .el-upload-list__item-thumbnail {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.barcode[data-v-b61e5f7c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
